import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const serviceGroupsUrl = `${SERVER_API}/service-groups`;
export const publicServiceGroupsUrl = `${SERVER_API}/public/service-groups`;

export default {
  SERVICE_GROUPS: {
    ...generateCrudEndpoints(serviceGroupsUrl),
  },
  PUBLIC_SERVICE_GROUPS: {
    LIST: {
      method: 'GET',
      url: `${publicServiceGroupsUrl}`,
    } as IEndpointData,
  },
};
